import React, { useEffect } from 'react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import './CartDrawer.css';

export default function CartDrawer() {
  const { items, removeFromCart, updateQty, total, itemCount, drawerOpen, setDrawerOpen } = useCart();
  const navigate = useNavigate();

  // Lock body scroll when open
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  // Close on Escape
  useEffect(() => {
    const fn = (e) => { if (e.key === 'Escape') setDrawerOpen(false); };
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, [setDrawerOpen]);

  const goCheckout = () => {
    setDrawerOpen(false);
    navigate('/checkout');
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className={`cd-backdrop${drawerOpen ? ' cd-backdrop--show' : ''}`}
        onClick={() => setDrawerOpen(false)}
      />

      {/* Drawer */}
      <div className={`cd${drawerOpen ? ' cd--open' : ''}`}>

        {/* Header */}
        <div className="cd__header">
          <div className="cd__header-left">
            <h2 className="cd__title">Your Cart</h2>
            {itemCount > 0 && (
              <span className="cd__count">{itemCount} item{itemCount !== 1 ? 's' : ''}</span>
            )}
          </div>
          <button className="cd__close" onClick={() => setDrawerOpen(false)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Items */}
        <div className="cd__items">
          {items.length === 0 ? (
            <div className="cd__empty">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
                stroke="#ddd" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 01-8 0"/>
              </svg>
              <p>Your cart is empty</p>
              <button onClick={() => { setDrawerOpen(false); navigate('/products'); }}>
                Shop Now
              </button>
            </div>
          ) : (
            items.map(item => (
              <div key={item.key} className="cd__item">
                {/* Image */}
                <div className="cd__item-img">
                  <img src={item.image} alt={item.name} />
                </div>

                {/* Info */}
                <div className="cd__item-info">
                  <p className="cd__item-brand">{item.brand}</p>
                  <p className="cd__item-name">{item.name}</p>
                  <p className="cd__item-meta">UK {item.size} · {item.colorway}</p>
                  <p className="cd__item-price">R {(item.price * item.qty).toLocaleString()}</p>
                </div>

                {/* Qty + remove */}
                <div className="cd__item-controls">
                  <div className="cd__qty">
                    <button onClick={() => updateQty(item.key, item.qty - 1)}>−</button>
                    <span>{item.qty}</span>
                    <button onClick={() => updateQty(item.key, item.qty + 1)}>+</button>
                  </div>
                  <button
                    className="cd__remove"
                    onClick={() => removeFromCart(item.key)}
                    aria-label="Remove"
                  >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="3 6 5 6 21 6"/>
                      <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                    </svg>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="cd__footer">
            <div className="cd__total-row">
              <span>Subtotal</span>
              <span className="cd__total">R {total.toLocaleString()}</span>
            </div>
            <p className="cd__note">Delivery calculated at checkout</p>
            <button className="cd__checkout-btn" onClick={goCheckout}>
              Proceed to Checkout
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
            <button className="cd__continue" onClick={() => setDrawerOpen(false)}>
              Continue Shopping
            </button>
          </div>
        )}
      </div>
    </>
  );
}